const isLoadingFullPage = state => state.commonStore.isLoadingFullPage
const loadingFlg = state => state.commonStore.loadingFlg
const isSidebarExpanded = state => state.commonStore.isSidebarExpanded
const isDisableSideMenuItem = state => state.commonStore.isDisableSideMenuItem
const isVerifyCode = state => state.authStore.isVerifyCode
const tokenExpireAt = state => state.authStore.expireAt
const currentStep = state => state.stepStore.currentStep
const toastMessage = state => state.commonStore.toastMessage
const isNegativeToastMessage = state => state.commonStore.isNegativeToastMessage
const breadcrumb = state => state.commonStore.breadcrumb
const prefectures = state => state.prefectureStore.prefectures
const profile = state => state.memberStore.profile
const menuLists = state => state.masterMenuStore.menuLists
const isGeneralDivision = state => state.authStore.isGeneralDivision
const displayPanels = state => state.mapStore.displayPanels
const legendPanel = state => state.mapStore.legendPanel
const ctrlPanel = state => state.mapStore.ctrlPanel
const infoPanel = state => state.mapStore.infoPanel
const mapClickModes = state => state.mapStore.mapClickModes
const mapClickMode = state => state.mapStore.mapClickMode
const ctrlPanelLabels = state => state.mapStore.ctrlPanelLabels
const simulationResultLists = state => state.simulationResultStore.simulationResultLists
const forestManagementComplexes = state => state.manageImportStore.forestManagementComplexes
const lastModifiedDateOfCsv = state => state.manageImportStore.lastModifiedDateOfCsv
const lastModifiedDateOfShapeFile = state => state.manageImportStore.lastModifiedDateOfShapeFile
const manageImportTabId = state => state.manageImportStore.manageImportTabId
const organizationId = state => state.authStore.organizationId
const roleId = state => state.authStore.roleId
const previousSetting = state => state.forestManagementPlanStore.previousSetting

const isSetToken = state => {
  return !!state.authStore.authToken
}

const isCallingApi = state => {
  for (const key in state.commonStore.isCallingApi) {
    if (state.commonStore.isCallingApi[key]) {
      return true
    }
  }
  return false
}

export default {
  isCallingApi,
  isLoadingFullPage,
  loadingFlg,
  isSidebarExpanded,
  isDisableSideMenuItem,
  isVerifyCode,
  isSetToken,
  tokenExpireAt,
  currentStep,
  toastMessage,
  isNegativeToastMessage,
  breadcrumb,
  prefectures,
  profile,
  menuLists,
  isGeneralDivision,
  displayPanels,
  legendPanel,
  ctrlPanel,
  infoPanel,
  mapClickModes,
  mapClickMode,
  ctrlPanelLabels,
  simulationResultLists,
  forestManagementComplexes,
  lastModifiedDateOfCsv,
  lastModifiedDateOfShapeFile,
  manageImportTabId,
  organizationId,
  roleId,
  previousSetting,
}
